import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center bg-brand-base text-brand-textMuted">Checking session…</div>;
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
};
